import Clickable from "./Clickable"
import { Pleb } from "../models/Pleb"
import React from "react"
import { useNavigate } from "react-router-dom"
import { ChatChannel, ChatChannelType } from "../models/ChatChannel"
import { BulkTypes } from "../models/BulkPayment"
import { SendTransactionStateRecipient } from "../store/slices/transactionSlice"

interface ButtonSendToProps {
    pleb: Pleb | null
    chatChannel?: ChatChannel | null,
    width?: number,
    onClickSend?: (data: SendTransactionStateRecipient) => void;
}

export const ButtonSendTo: React.FC<ButtonSendToProps> = ({ pleb, chatChannel, width = 50, onClickSend }) => {
    const navigate = useNavigate();

    let recipientOnClick: SendTransactionStateRecipient | null = null;

    if(pleb && pleb.hasWallet())
        recipientOnClick = {
            pleb: pleb,
            lnurl: '',
            bulkPayment: null
        };
    if(chatChannel && chatChannel.type === ChatChannelType.Group)
        recipientOnClick = {
            pleb: null,
            lnurl: '',
            bulkPayment: {
                type: BulkTypes.group,
                id: chatChannel.id,
                name: chatChannel.name ?? '',
                recipientsCount: chatChannel.memberCount - 1
            }
        };
    if(chatChannel && chatChannel.type === ChatChannelType.Event)
        recipientOnClick = {
            pleb: null,
            lnurl: '',
            bulkPayment: {
                type: BulkTypes.event,
                id: chatChannel.id,
                name: chatChannel.name ?? '',
                recipientsCount: chatChannel.memberCount - 1
            }
        };
    
    if(recipientOnClick)
        return <Clickable 
            className="cursor-pointer flex items-center justify-center rounded-xl h-[50px]" 
            onClick={(e: React.MouseEvent<HTMLElement>) => {
                e.stopPropagation();
                if(onClickSend && recipientOnClick) {
                    onClickSend(recipientOnClick);
                } else {
                    const recipientOnClickJson = recipientOnClick as any;

                    if(recipientOnClickJson.pleb)
                        recipientOnClickJson.pleb = recipientOnClickJson.pleb.toJson();

                    navigate('/home/wallet/send/recipient', {
                        state: {
                            recipient: recipientOnClick
                        }
                    });
                }
                    
            }}
            style={{ width: width + 'px'}}
        >
            <span className="material-icons text-brand-orange text-[40px]">bolt</span>
        </Clickable>;

    return null;
}